export default "__VITE_ASSET__Cj7xwj9I__"